import React from "react";

function CRTOverlay() {
  return (
    <>
      <div className="crt-overlay" aria-hidden="true" />
      <div className="screen-vignette" aria-hidden="true" />
    </>
  );
}

export default CRTOverlay;
